/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Header scrolling hide/show
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(
    ".shopify-section.shopify-section-group-header-group.shopify-section__header",
  );
  const header = wrapper ? wrapper.querySelector(".header") : null;
  const navBar = wrapper ? wrapper.querySelector(".nav-bar") : null;
  const desktopQuery = window.matchMedia("(min-width: 1000px)");
  const stateClasses = [
    "custom-header--at-top",
    "custom-header--nav-only",
    "custom-header--full",
  ];
  const scrollThreshold = 100;
  const deltaThreshold = 5;
  let lastScrollY = window.scrollY;
  let currentState = "";

  if (!wrapper || !header || !navBar) return;

  function setHeaderState(state) {
    if (currentState === state) return;

    wrapper.classList.remove(...stateClasses);
    wrapper.classList.add(state);
    currentState = state;
  }

  function updateHeaderMainHeight() {
    wrapper.style.setProperty(
      "--custom-header-main-height",
      `${header.offsetHeight}px`,
    );
  }

  function resetHeaderState() {
    wrapper.classList.remove(...stateClasses);
    wrapper.style.removeProperty("--custom-header-main-height");
    currentState = "";
  }

  function syncHeaderState() {
    updateHeaderMainHeight();

    if (!desktopQuery.matches) {
      resetHeaderState();
      lastScrollY = window.scrollY;
      return;
    }

    const currentScrollY = window.scrollY;
    const scrollDelta = Math.abs(currentScrollY - lastScrollY);

    if (currentScrollY <= 0) {
      setHeaderState("custom-header--at-top");
    } else if (currentState === "" && currentScrollY > scrollThreshold) {
      setHeaderState("custom-header--nav-only");
    } else if (currentState === "") {
      setHeaderState("custom-header--full");
    } else if (currentScrollY < lastScrollY && scrollDelta > deltaThreshold) {
      setHeaderState("custom-header--full");
    } else if (
      currentScrollY > lastScrollY &&
      currentScrollY > scrollThreshold &&
      scrollDelta > deltaThreshold
    ) {
      setHeaderState("custom-header--nav-only");
    }

    lastScrollY = currentScrollY;
  }

  updateHeaderMainHeight();
  syncHeaderState();

  window.addEventListener("scroll", syncHeaderState, { passive: true });
  window.addEventListener("resize", syncHeaderState);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener("change", syncHeaderState);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(syncHeaderState);
  }
});

// Fix search results and nav-bar layer issue
const searchWrapper = document.querySelector(".header__search-bar-wrapper");
const wrapper = document.querySelector(".shopify-section__header");

if (searchWrapper && wrapper) {
  const observer = new MutationObserver(() => {
    if (searchWrapper.classList.contains("is-fixed")) {
      wrapper.classList.add("search-active");
    } else {
      wrapper.classList.remove("search-active");
    }
  });

  observer.observe(searchWrapper, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

// Product label colour
document.querySelectorAll(".product-label").forEach((label) => {
  const text = label.textContent.trim().toLowerCase();

  if (text === "clearance") {
    label.classList.add("product-label--clearance");
  }

  if (text === "instructor pick") {
    label.classList.add("product-label--instructor-pick");
  }
});

// Automatically hide cart promotion messages at their configured end time.
document.addEventListener("DOMContentLoaded", () => {
  const promotionSelector = "[data-cart-promotion-end-at]";
  const maximumTimerDelay = 2147483647;
  let expirationTimerId;

  function hidePromotion(promotion) {
    promotion.hidden = true;

    const alertWrapper = promotion.closest(".mini-cart__alert-wrapper");

    if (
      alertWrapper &&
      !alertWrapper.querySelector(".alert, .cart-promotion-progress:not([hidden])")
    ) {
      alertWrapper.hidden = true;
    }
  }

  function syncPromotionExpiry() {
    window.clearTimeout(expirationTimerId);

    const now = Date.now();
    let nextExpiration = null;

    document.querySelectorAll(promotionSelector).forEach((promotion) => {
      const endTime = Date.parse(promotion.dataset.cartPromotionEndAt);

      if (Number.isNaN(endTime)) return;

      if (now >= endTime) {
        hidePromotion(promotion);
      } else if (nextExpiration === null || endTime < nextExpiration) {
        nextExpiration = endTime;
      }
    });

    if (nextExpiration !== null) {
      const delay = Math.min(
        Math.max(nextExpiration - now + 100, 0),
        maximumTimerDelay,
      );

      expirationTimerId = window.setTimeout(syncPromotionExpiry, delay);
    }
  }

  document.addEventListener("cart:rerendered", syncPromotionExpiry, true);
  syncPromotionExpiry();
});
